/**
 * SupportLogo component.
 */
import FlavourConfig from '@shared/config/flavours';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withImage from '@shared/components/utils/hoc/withImage';

/**
 * Styled support flavour logo.
 */
const SupportLogo = styled.img<React.CSSProperties>`
  align-self: center;
  height: auto;
  margin-bottom: ${46 * Screen.widthRatio}px;
  width: ${FlavourConfig.sizes.supportLogo * Screen.widthRatio}px;
`;

SupportLogo.defaultProps = {
  src: FlavourConfig.images.logo,
};

export default withImage(SupportLogo);
